import { DEFAULT_PAGE_SIZE } from "common/config";
import { DocSetupState } from "../../models/document-setup-state.model";

const initialDocSetupState: DocSetupState = {
  currentPageDetails: {
    page: 1,
    size: DEFAULT_PAGE_SIZE,
    sort: "",
    dir: "",
    search: ""
  },
  hasDuplicate: false
};

export { initialDocSetupState };
